export default __webpack_public_path__ + "static/media/story-2.c41ca95e.png";